<div class="account-shell__loading animated faster fadeIn" *ngIf="loading">
  <div class="ui-loader ui-loader__page-light"></div>
</div>

<div class="account-shell__content profile-booking-customer" *ngIf="!loading">
  <div class="pg-wrapper">
    <p class="txt-caption text-center mb-4" *ngIf="tokenError">{{ tokenError }}</p>
    <p class="txt-caption text-center mb-4 profile-booking-customer__error" *ngIf="loadError">{{ loadError }}</p>

    <ng-container *ngIf="editForm && profile && !tokenError && !loadError">
      <div class="profile-booking-customer__tabs mb-4">
        <button type="button" class="ui-buttons mr-2" [ngClass]="activeTab === 'profile' ? 'ui-buttons__blue-small' : 'ui-buttons__light-small'" (click)="setTab('profile')">Профиль</button>
        <button type="button" class="ui-buttons" [ngClass]="activeTab === 'applications' ? 'ui-buttons__blue-small' : 'ui-buttons__light-small'" (click)="setTab('applications')">Входящие заявки</button>
      </div>

      <ng-container *ngIf="activeTab === 'profile'">
        <form [formGroup]="editForm" (keydown.enter)="$event.preventDefault()" autocomplete="off">
          <div class="account-shell__content-wrapper" ngClass="{{(deviceValue | async) === DTypes.Mobile ? '' : 'pl-3 pr-3'}}">
            <div class="account-shell__content-subtitle">
              <h5>{{ displayName() }}</h5>
            </div>
          </div>

          <div class="account-shell__content-wrapper">
            <div class="grid align-items-start">
              <div class="col-4 col-sm-12">
                <div class="profile-booking-customer__main-photo" (click)="openMainPhotoEditDialog()">
                  <img *ngIf="profileImageSrc() as simg" [src]="simg" alt="" class="profile-booking-customer__main-photo-img" />
                  <div *ngIf="!profileImageSrc()" class="profile-booking-customer__main-photo-placeholder">
                    <i class="pi pi-image"></i><span>Нет фото</span>
                  </div>
                </div>
              </div>
              <div class="col-8 col-sm-12">
                <p class="profile-booking-customer__readonly-line" *ngIf="formatPhone() as ph">Телефон: {{ ph }}</p>
                <p class="txt-caption" *ngIf="profile.registrationData?.registrationNumber as inn">ИНН: {{ inn }}</p>
              </div>
            </div>
          </div>

          <div class="account-shell__content-wrapper pl-3 pr-3">
            <div class="account-shell__forms-input mb-3">
              <div class="ui-input__placeholder"><p>Город</p><span class="require">*</span></div>
              <p-dropdown formControlName="city" [options]="Cities" optionLabel="name" optionValue="id" placeholder="Выберите город" [filter]="true" styleClass="p-dropdown__bulletins"></p-dropdown>
            </div>
            <app-venue-customer-profile-fields [form]="editForm" [genres]="Genres" layout="dialog"></app-venue-customer-profile-fields>
            <app-venue-customer-facilities-fields [form]="editForm" layout="dialog"></app-venue-customer-facilities-fields>

            <div class="account-shell__content-subtitle mt-4">
              <h5>Фотоальбом</h5>
            </div>
            <div class="profile-booking-customer__gallery mb-3">
              <img *ngFor="let url of galleryPreviewUrls()" [src]="url" alt="" class="profile-booking-customer__gallery-thumb" />
              <p class="txt-caption m-0" *ngIf="!galleryPreviewUrls().length">Фото пока не добавлены.</p>
            </div>
            <button type="button" class="ui-buttons ui-buttons__light-small mb-3" (click)="openGalleryEditDialog()">Редактировать фотоальбом</button>

            <div class="sign-up__forms-input mt-3">
              <div class="ui-input__placeholder"><p>Телефон для контактов</p><span class="require">*</span></div>
              <div class="ui-input ui-input__text"><input type="tel" formControlName="phone" placeholder="+7" /></div>
            </div>

            <div class="account-shell__content-subtitle mt-4">
              <h5>Ссылки на соцсети <span class="require">*</span></h5>
            </div>
            <p class="txt-caption profile-booking-customer__edit-global-error" *ngIf="editGlobalError">{{ editGlobalError }}</p>
            <div formArrayName="socialLinks">
              <div *ngFor="let c of socialLinksEditArray.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i" class="profile-booking-customer__social-row mb-2">
                <p-dropdown [options]="SocialPlatforms" optionLabel="name" optionValue="value" formControlName="platform" styleClass="p-dropdown__bulletins"></p-dropdown>
                <div class="ui-input ui-input__text mt-2"><input type="url" formControlName="url" placeholder="https://" /></div>
                <button type="button" class="ui-buttons ui-buttons__light-small mt-2" (click)="removeSocialLinkEdit(i)">Удалить</button>
              </div>
              <button type="button" class="ui-buttons ui-buttons__light-small mt-2" (click)="addSocialLinkEdit()">Добавить ссылку</button>
            </div>
          </div>

          <div class="account-shell__content-wrapper">
            <div class="account-shell__content-button">
              <button type="button" class="ui-buttons ui-buttons__blue-large" (click)="saveProfile()" [disabled]="editSubmitLoading">Сохранить</button>
            </div>
          </div>
        </form>
      </ng-container>

      <app-profile-booking-venue-applications *ngIf="activeTab === 'applications'" [bookingCustomerId]="bookingCustomerId"></app-profile-booking-venue-applications>
    </ng-container>
  </div>

  <p-confirmDialog [appendTo]="'body'" [styleClass]="'p-dialog__confirm'"></p-confirmDialog>
</div>
